export class FiscalModel { 
    field01: string;
    field02: string;
    field03: string;
    field04: string;
    field05: string;
    field06: string;
    field07: string;
    field12: string;
    field14: string;
    field17: string;
    trimester: number;
    model: number;

    constructor() { }
}    